import { cn, focusHaloFlush, HapticSurface, panelMotion, press } from "@pax/ui";
import { useQuery } from "@tanstack/react-query";
import { useSession } from "@/features/auth/queries";
import { formatCredits } from "../format";
import { creditBalanceQuery } from "../queries";
import { useTopUp } from "../top-up";
import { Coin } from "./Coin";

/** A 32px target around a 28px chip, the same height as your picture beside it. */
const target = `group relative flex h-8 shrink-0 items-center rounded-full ${press} ${focusHaloFlush}`;
const chip = `flex h-7 items-center gap-1.5 rounded-full bg-foreground/[0.06] pr-2.5 pl-1 text-sm font-medium tabular-nums group-hover:bg-foreground/10 ${panelMotion}`;

/**
 * The credits you can spend, on a soft ground, which opens buying more. In the sidebar it ends your
 * name's row; in the bar it sits beside your picture.
 */
export function CreditsPill({ className }: { className?: string }) {
  const { data: session } = useSession();
  const signedIn = Boolean(session?.user);
  const { data: credits } = useQuery({
    ...creditBalanceQuery(session?.user.id ?? ""),
    enabled: signedIn,
  });
  const { openTopUp } = useTopUp();

  if (!signedIn) return null;

  const balance = credits === undefined ? "–" : formatCredits(credits);

  return (
    <button
      type="button"
      onClick={() => openTopUp()}
      aria-label={`${balance} credits. Buy credits`}
      className={cn(target, className)}
    >
      <span className={chip}>
        <Coin className="size-[18px]" />
        <span>{balance}</span>
      </span>
      <HapticSurface />
    </button>
  );
}
